import { Injectable } from "@angular/core";
import { IStepTypeProviderDescription } from "../interfaces";
import { LogClass, Logger } from "../logger";

@Injectable()
@LogClass({ source: "StepService" })
export class StepService {
  private logger: Logger;
  private providers: IStepTypeProviderDescription[] = [];

  constructor() {
    this.logger.debug("ctor");
  }

  public getType(id: string): IStepTypeProviderDescription {
    return this.getTypes().find((x) => x.id === id);
  }

  public getTypes(): IStepTypeProviderDescription[] {
    return this.providers.map((p) => {
      return { ...p };
    });
  }

  public register(description: IStepTypeProviderDescription): void {
    this.logger.debug("register:" + description.id);
    const existing = this.providers.find((x) => x.id === description.id);
    if (existing) {
      throw new Error(
        `provider for id:${description.id} was already registerd.`
      );
    }

    this.providers.push({ ...description });
  }
}
